<template>
   <div class="payments">
     <div v-if="Number(userInfo.exam_pay_status.status) === 1" class="paycode" style="padding-top: 100px;">
        <!-- 放置二维码的容器,需要给一个ref -->
        <div id="qrcode2" style="width:150px;margin:auto" ref="qrcode"></div>
        <div v-if="payPrice" class="price-txt">微信扫码缴费</div>
     </div>
     <div v-else class="profile-mod-status">{{ userInfo.exam_pay_status.status_text }}</div>
   </div>
</template>
<script>
import QRCode from "qrcodejs2";
import axios from "axios";
import {mapState} from 'vuex'

export default {
   name: '',
   components: {
     
   },
   mixins: [],
   props: {
     
   },
   data() {
     return {
       payPrice: false,
       wxPaySetInteval: ''
     }
   },
   computed:mapState([
        'userInfo',
    ]),
   watch: {
     
   },
   mounted() {
    if(Number(this.userInfo.exam_pay_status.status) === 1){
      this.startPay()
    }
   },
   methods: {
     async startPay(){
        const params = {
            // item_id: this.type,
            type: 2,
            token: localStorage.getItem("ifm_token"),
        };
        this.load = true;
        const res = await axios.post(
            "/api/pay/wechatInit?token=" + localStorage.getItem("ifm_token"),
            params
        );
        if (res.status === 200) {
            this.load = false;
            this.payPrice = true;
            this.$nextTick(() => {
            this.qr = new QRCode("qrcode2", {
                width: 150,
                height: 150, // 高度
                text: res.data.data.url, // 二维码内容
            });
            });
            this.listenWxPayResult(res.data.data.order_no);
        }
        },
        listenWxPayResult(no) {
            this.wxPaySetInteval = setInterval(async () => {
                const params = {
                order_no: no,
                token: localStorage.getItem("ifm_token"),
                };
                const res = await this.$http.get(
                "/api/pay/getPayStatus?token=" + localStorage.getItem("ifm_token"),
                params
                );
                if (res) {
                if (Number(res.pay_succ) === 1) {
                    this.userInfo.exam_pay_status.status = 2;
                    this.userInfo.exam_pay_status.status_text = '已支付';
                    this.$toast("支付成功");
                    this.closeCode();
                    this.innerVisible = false;
                }
                }
            }, 2000);
        },
   },
};
</script>
<style lang='scss' scoped>
.payments{
    width: 100%;
    height: 100%;
    background-color: #fff;
}
.price-txt {
  text-align: center;
  padding-top: 20px;
  font-size: 16px;
}
</style>